/**
 * Shared SVG icon constants
 * Deduplicated from bookmarks.ts, tribes.ts, FolderCard.ts, NoteMenu.ts
 * Uses sprite sheet references from public/icons.svg
 */

export const ICON_TRASH_16 = `<svg width="16" height="16"><use href="#icon-trash"/></svg>`;

export const ICON_TRASH_14 = `<svg width="14" height="14"><use href="#icon-trash"/></svg>`;

export const ICON_PLUS = `<svg width="14" height="14"><use href="#icon-plus"/></svg>`;

export const ICON_CHEVRON_DOWN = `<svg width="10" height="10" class="bookmark-header__new-chevron"><use href="#icon-chevron-down"/></svg>`;
